<template>
  <div>
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <!-- <span class="sr-only">Loading...</span> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onErrorCaptured } from "vue";
import ProspectService from "@/services/prospect/prospectService";
import store from "@/store";
import router from "@/router";
import { useRoute } from "vue-router";
import { localStorageBoolean } from "@/utils/constants";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";

const verifyProspect = (token, recaptcha) => {
  const prospectService = new ProspectService();

  prospectService.verifyProspect({ token, recaptcha }).then(
    (response) => {
      if (response && response.data && Object.keys(response.data).length > 0) {
        sessionStorage.setItem(
          "prospectCallbackInfo",
          JSON.stringify(response.data),
        );
        sessionStorage.setItem("sessionStarted", localStorageBoolean.true);
        store.dispatch("Prospect/authenticateProspect");
        router.push({ path: "/prospectVerifyEmail" });
      }
    },
    (error) => {
      if (
        error &&
        error.status == 401 &&
        error.data &&
        error.data.error &&
        error.data.error.type
      ) {
        if (error.data.error.type === "exc_prosp_verify-2") {
          store.dispatch("Prospect/setPreProspectSession");
          router.push({ path: "/prospectExistingUser" });
        } else if (
          error.data.error.type === "exc_prospect_org_domain_exists-1"
        ) {
          store.dispatch("Prospect/setPreProspectSession");
          router.push({ path: "/prospectExistingOrg" });
        } else {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data.error),
          );
          router.push({ path: "/" });
        }
      } else if (
        error &&
        error.status &&
        error.data &&
        error.data.error &&
        error.data.error.type
      ) {
        sessionStorage.setItem(
          "prospectCallbackErrorInfo",
          JSON.stringify(error.data.error),
        );
        router.push({ path: "/" });
      }
    },
  );
};

const getRecaptcha = async () => {
  try {
    const finalKey = await Utils.getV3Recaptcha();
    const recaptcha = await load(`${finalKey}`, {
      autoHideBadge: true,
    });
    const token = await recaptcha.execute("submit");
    return token;
  } catch (error: any) {
    console.log(error);
  }
};

onMounted(async () => {
  const route = useRoute();
  if (route.query && route.query.token) {
    const recaptcha = await getRecaptcha();
    verifyProspect(route.query.token as string, recaptcha);
  } else {
    // Redirect to the landing page if the token does not exist in params.
    router.push({ path: "/" });
  }
});

onErrorCaptured((err) => {
  return false;
});
</script>
